import angular from 'angular';
import ngCookies from 'angular-cookies';
import constants from 'app/constants';


let _$cookies;

export class authorizationService {
  constructor($cookies, cookieNames) {
    _$cookies = $cookies;
    this.cookieNames = cookieNames;
    console.log('app.services.authorizationService created');
  }

  setToken(token) {
    _$cookies.putObject(
      this.cookieNames.token,
      token
    );
  }

  revokeToken() {
    _$cookies.remove(this.cookieNames.token);
  }

  getToken() {
    return _$cookies.getObject(this.cookieNames.token);
  }
}

authorizationService.$inject = [
  '$cookies',
  'cookieNames',
];

export default angular.module('app.services.authorizationService', [
  ngCookies,
  constants
])
  .service('authorizationService', authorizationService)
  .name;
